import classNames from "classnames";
import { useCallback } from "react";
import { TreeNode, TreeNodeType } from "~/components/build/Show/components/Sidebar/TreeNode";
import { useBuildStore } from "~/components/build/Show/lib/useBuildStore";
import { CommandStep } from "~/lib/pipeline";

/** @deprecated Use `~/components/build/Show/routes/steps/list/-components/TreeNode/CommandStepExpandItem` instead. */
export const CommandStepExpandItem = ({ hiddenCount, step, depth = 0 }) => {
  const showHiddenJobs = useBuildStore((state) => state.showHiddenJobs);

  const onClick = useCallback(() => {
    showHiddenJobs(step.uuid);
  }, [showHiddenJobs, step.uuid]);

  return (
    <button
      onClick={onClick}
      className={classNames(
        "text-charcoal-300 hover:bg-purple-100-50-white flex w-full cursor-pointer rounded-md px-1.5 py-1 text-left text-xs/5",
        {
          // Indentation based on depth
          "pl-[calc(1.5rem_+_2px)]": depth === 1, // + 2px to account for chevron padding
          "pl-[calc(2.5rem_+_4px)]": depth === 2, // + 4px to account for chevron padding
        },
      )}
    >
      Show {hiddenCount} hidden {hiddenCount === 1 ? "job" : "jobs"}
    </button>
  );
};

/** @deprecated Use `~/components/build/Show/routes/steps/list/-components/TreeNode/CommandStepExpandItem` instead. */
export const createShowHiddenJobsNode = (step: CommandStep, hiddenCount: number): TreeNode => ({
  id: `hidden-jobs-${step.uuid}`,
  type: TreeNodeType.ShowHiddenJobs,
  render: (props) => <CommandStepExpandItem hiddenCount={hiddenCount} step={step} {...props} />,
});
